import classNames from 'classnames';
import React, { PureComponent } from 'react';
import { Skeleton } from '../skeleton';
import LabelStatus from 'components/ui/labelStatus';
import Mapper from 'helpers/Mapper';
import './teaser.scss';

interface Props {
  title: string;
  text: string | JSX.Element;
  status?: string;
  isLoading?: boolean;
}

class Teaser extends PureComponent<Props> {
  render() {
    const { status, title, text, children, isLoading } = this.props;

    return (
      <div
        className={classNames('ui-teaser', {
          'ui-teaser_loading': isLoading,
        })}>
        <div className='ui-teaser__content'>
          {status && (
            <div className='ui-teaser__status'>
              {isLoading ? (
                <Skeleton width={50} height={20} isLight />
              ) : (
                <LabelStatus
                  status={Mapper.getStatus(status?.toLowerCase())}
                  text={status}
                />
              )}
            </div>
          )}
          <div className='ui-teaser__title'>
            {isLoading ? <Skeleton width={150} height={24} isLight /> : title}
          </div>
          <div className='ui-teaser__text'>
            {isLoading ? <Skeleton width={250} height={20} isLight /> : text}
          </div>
        </div>
        <div className='ui-teaser__actions'>
          {isLoading ? <Skeleton width={200} height={30} isLight /> : children}
        </div>
      </div>
    );
  }
}

export default Teaser;
